var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 16,
  fill: "none",
  viewBox: "0 0 18 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9 1.813a2.938 2.938 0 1 0 0 5.875 2.938 2.938 0 0 0 0-5.875M4.437 4.75a4.562 4.562 0 1 1 9.125 0 4.562 4.562 0 0 1-9.124 0ZM9 12.646c-2.666 0-5.1 1.16-6.909 3.078A.812.812 0 1 1 .91 14.609C2.994 12.4 5.844 11.021 9 11.021s6.007 1.377 8.091 3.588a.812.812 0 1 1-1.182 1.115C14.1 13.806 11.666 12.646 9 12.646",
  clipRule: "evenodd"
})));
SvgUserOutline.displayName = "SvgUserOutline";
export { SvgUserOutline as ReactComponent };
export default SvgUserOutline;